module.exports = __webpack_public_path__ + "static/media/wizualizacja-135.4767c80f.png";